import { WEBGL } from 'three/examples/jsm/WebGL';
import { getJqContainer } from './utils';
import * as THREE from 'three';
import { disposePmremGenerator } from './factories/pmrem-generator.factory';

const CLASS_NAME__ERROR = 'model-viewer-3d-error';
const CLASS_NAME__LOADED = 'model-viewer-3d-loaded';

export {
    checkWebGL,
    createRenderer,
    getJqContainer,
    releaseResources,
    renderError,
    renderScene,
    renderWebGLError,
};

function checkWebGL() {
    return !!WEBGL.isWebGLAvailable();
}

function createRenderer({ width, height }) {
    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    return renderer;
}

function renderWebGLError(selectorContainer) {
    const warning = WEBGL.getWebGLErrorMessage();
    getJqContainer(selectorContainer).append(warning);
}

function renderScene({
    selectorContainer,
    camera,
    controls,
    renderer,
    scene,
    background,
    environmentMap,
    loadedScene,
}) {
    // Add created camera to scene
    scene.add(camera);
    scene.add(loadedScene);

    _appendCanvas(selectorContainer, renderer);
    _requestAnimationFrame({ scene, camera, controls, renderer });
    _renderLoaded(selectorContainer);

    if (environmentMap) scene.environment = environmentMap;
    if (background) scene.background = background;

    releaseResources(environmentMap);
}

function renderError(selectorContainer) {
    getJqContainer(selectorContainer).addClass(CLASS_NAME__ERROR);
}

function _appendCanvas(selectorContainer, renderer) {
    getJqContainer(selectorContainer).append(renderer.domElement);
}

function _requestAnimationFrame({ scene, camera, controls, renderer }) {
    function animate() {
        requestAnimationFrame(animate);
        controls.update();
        renderer.render(scene, camera);
    }
    animate();
}

function _renderLoaded(selectorContainer) {
    getJqContainer(selectorContainer).addClass(CLASS_NAME__LOADED);
}

function releaseResources(environmentMap) {
    environmentMap && environmentMap.dispose();
}
